import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-self: flex-start;

  > h2 {
    line-height: .9;
    text-align: right;
  }
`

const InlineBlock = styled.span`
  display: inline-block;
`

export { Container, InlineBlock }
